var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJoinIconBlack24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M5.432 14.568a7.42 7.42 0 1 0 9.136-9.136 7.42 7.42 0 1 0-9.136 9.136Zm9.355-6.287a4.839 4.839 0 1 1-6.51 6.506 7.419 7.419 0 0 0 6.51-6.51v.004Zm-7.029 3.961a4.839 4.839 0 0 1 4.484-4.484 4.838 4.838 0 0 1-4.484 4.484ZM7.42 2.581a4.84 4.84 0 0 1 4.303 2.632 7.419 7.419 0 0 0-6.51 6.51A4.84 4.84 0 0 1 7.42 2.58Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoinIconBlack24);
export default __webpack_public_path__ + "static/media/join-icon-black-24.ea8907b72597dfd23284765eb29c31ad.svg";
export { ForwardRef as ReactComponent };